export function getEntityById<T extends { id: number }>(
  collection: T[],
  idStr: string | null | undefined
): T | undefined {
  if (!idStr?.trim()) {
    return undefined;
  }
  return collection.find((item) => item.id === Number(idStr));
}

export function getLabelFromId<T extends { id: number; name?: string | null }>(
  collection: T[],
  idStr: string | null | undefined
): string | null {
  const entity = getEntityById(collection, idStr);
  return entity?.name?.trim() || null;
}
